import { OVField, OVForm, OVTable, OVSearchable, OVEntity, OVSearch } from '@ov-suite/ov-metadata';
import { DomainModel, Inventory, InventoryLocationModel } from '@ov-suite/models-admin';

@OVEntity('InventoryContainerType', 'warehouselink')
export class InventoryContainerType {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: 'string' })
  name: string;

  @OVField({ type: 'string' })
  description: string;
}

@OVEntity('InventoryContainer', 'warehouselink')
@OVForm(
  [['#Container Details'], ['name', 'description'], ['type', 'domains'], ['barcodeData', ''], ['qrPreview']],
  [['#Container Details'], ['name', 'description'], ['barcodeData', ''], ['qrPreview']],
)
@OVTable<InventoryContainer>([
  {
    key: 'name',
    title: 'Container Name',
    type: 'string',
    detailModal: ({ id }) => ({
      id,
      entity: InventoryContainer,
    }),
  },
  {
    key: 'inventoryLocation.name',
    title: 'Location',
    type: 'deep-string',
  },
  {
    title: 'Inventory',
    type: 'other',
    action: ic =>
      ic.inventories
        .map(i => i.productSku?.name)
        .filter(i => !!i)
        .join(', '),
    disableSorting: true,
    keys: ['inventories.productSku.name'],
  },
  {
    title: 'Inventory Count',
    type: 'other',
    disableSorting: true,
    action: ic => ic.inventories?.reduce((p, c) => p + c.quantity, 0).toString(),
    keys: ['inventories', 'inventories.quantity'],
    disableFiltering: true,
  },
  {
    title: 'Container Type',
    type: 'other',
    keys: ['type.name'],
    action: inventoryContainer => inventoryContainer.type?.name ?? 'Not Set',
    disableSorting: true,
  },
])
@OVSearch<InventoryContainer>({ searchKeys: ['name', 'barcodeData', 'type.name'] })
export class InventoryContainer {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true,
  })
  id: number;

  @OVField({
    type: 'string',
    title: 'Description',
    placeholder: 'Required',
    required: false,
  })
  description: string;

  @OVField({
    type: 'string',
    title: 'Barcode Type',
    placeholder: 'Required',
    required: false,
  })
  barcodeType?: string;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Barcode Data',
    placeholder: 'Required',
    required: false,
  })
  barcodeData?: string;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Container Name',
    placeholder: 'Required',
    required: true,
  })
  name: string;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Created By',
    placeholder: 'Required',
    required: false,
  })
  createdBy?: string;

  @OVField({
    type: () => InventoryContainerType,
    selectionType: 'simple',
    flat: true,
    title: 'Type',
    required: true,
  })
  type: InventoryContainerType;

  @OVField({
    type: 'domain-selector',
    title: 'Domains',
    required: true,
    readonly: true,
    generated: true,
  })
  domains: DomainModel[];

  @OVField({
    type: 'code-preview',
    unnecessary: true,
    codeKey: 'barcodeData',
  })
  qrPreview: void;

  @OVField({ type: () => InventoryLocationModel })
  inventoryLocation: InventoryLocationModel;

  @OVField({ type: () => [Inventory] })
  inventories: Inventory[];
}
